import { useGetExportListV2Query } from "../../../services/ExportV2/exportV2API";
import { ExportModuleIdParam } from "../../../services/ExportV2/exportV2API.types";

export const useExportListData = (params: ExportModuleIdParam, options: { skip?: boolean } = {}) => {
  const {
    isFetching,
    data: exportListData,
    refetch,
  } = useGetExportListV2Query(params, { ...options, skip: options.skip });

  return {
    isFetching,
    data: exportListData,
    refetch: refetch,
  };
};
